type SentryOptionsInput = {
  dsn?: string
  environment?: string
  localEnabled?: string
  nodeEnvironment?: string
}

const normalize = (value?: string) => value?.trim().toLowerCase()

/**
 * Sentry reports from supported deployments except product Dev by default.
 * Developers can opt in locally for intentional instrumentation tests.
 */
export const getSentryOptions = ({
  dsn,
  environment,
  localEnabled,
  nodeEnvironment,
}: SentryOptionsInput) => {
  const normalizedDsn = dsn?.trim() || undefined
  const normalizedEnvironment = normalize(environment) || 'dev'
  const isLocalRuntime = normalize(nodeEnvironment) === 'development'
  const isLocalOptIn = isLocalRuntime && localEnabled === 'true'
  // AWS production accounts follow <customercode>-prod (including hivewatch-prod):
  // https://hivewatch.atlassian.net/wiki/spaces/EN/pages/1607761927
  // The deployment workflow passes that name through NEXT_PUBLIC_ENVIRONMENT.
  const isProductionEnvironment = normalizedEnvironment.endsWith('-prod')
  const isReportingEnvironment =
    isProductionEnvironment ||
    [
      'hivewatch-test',
      'hivewatch-sales',
      'hivewatch-pentest',
      'ssvc-dev',
      'ssvc-data',
    ].includes(normalizedEnvironment)
  const shouldInitialize = isLocalRuntime
    ? isLocalOptIn
    : isReportingEnvironment

  if (!normalizedDsn || !shouldInitialize) return undefined

  // Use SENTRY_RELEASE instead of setting release here so source maps share it.
  return {
    dsn: normalizedDsn,
    environment: isLocalOptIn ? 'local' : normalizedEnvironment,
    initialScope: isLocalOptIn ? { tags: { local_opt_in: 'true' } } : undefined,
    tracesSampleRate: 1.0,
  }
}
